import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import { StepChart } from "@clientFrontend/components/StepChart";
import { PreviewButtons } from "@clientFrontend/features/publication/components/PreviewButtons";
import { PrimaryActionWithNotification } from "@clientFrontend/features/publication/components/PrimaryActionWithNotification";
import { PublicationArticleContainer } from "@clientFrontend/features/publication/components/PublicationArticleContainer";
import { WorkContentDetail } from "@clientFrontend/features/publication/components/WorkContentDetail";
import type { WorkContent } from "@clientFrontend/features/publication/components/WorkContentDetail/type";
import * as styles from "./styles.css";

type Props = {
  step1Url: string;
  step2Url: string;
  editUrl: string;
  canEdit: boolean;
  canPreview: boolean;
  workContent: WorkContent;
  dummyImgPath: string;
  workId: string;
  site: "biyo" | "kaigo";
};

export const WorkContentShowStep1: FC<Props> = ({
  step1Url,
  step2Url,
  editUrl,
  canEdit,
  canPreview,
  workContent,
  dummyImgPath,
  workId,
  site,
}) => {
  return (
    <PublicationArticleContainer>
      <Heading tag="h1" size="xLarge" bold className={styles.pageTitle}>
        基本情報
      </Heading>
      <StepChart
        currentStep={1}
        step1Name="基本情報"
        step2Name="詳細情報"
        step1Url={step1Url}
        step2Url={step2Url}
        site={site}
      />
      <div className={styles.actions}>
        <PrimaryActionWithNotification
          text="編集する"
          url={editUrl}
          iconName="edit"
          canAction={canEdit}
          cannotActionType="inactive"
        >
          <p className={styles.approvingDuration}>
            ご申請から反映までの目安&nbsp;
            <span className={styles.approvingDurationExp}>最大3営業日以内</span>
          </p>
        </PrimaryActionWithNotification>
        <PreviewButtons canPreview={canPreview} workId={workId} />
      </div>
      <WorkContentDetail
        editUrl={editUrl}
        canEdit={canEdit}
        workContent={workContent}
        dummyImgPath={dummyImgPath}
        site={site}
      />
    </PublicationArticleContainer>
  );
};
